<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span slot="title">Select Service</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params : params }" class="m-nav__link">
            <i class="m-nav__link-icon la la-home"></i>
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
      </ul>
    </bread-crumb>
    <dash-content>
      <div class="row" slot="content">
        <div v-for="(service,index) in services" :key="index" class="col-xl-4">
          <router-link :to="{ name: servicesConfig[service.name].routeName, params: params}">
            <div class="m-portlet">
              <div class="m-portlet__body" :class="servicesConfig[service.name].bgColor">
                <div class="tab-content">
                  <div class="tab-pane active" id="m_widget4_tab1_content">
                    <div class="m-widget4">
                      <div class="m-widget4__item ">
                        <div class="m-widget4__info">
                          <span class="text-white m--regular-font-size-lg3 m--font-boldes">
                            {{ servicesConfig[service.name].abbr }}
                          </span>
                          <br>
                          <span class="m-widget4__sub text-white">
                            {{ servicesConfig[service.name].name }}
                          </span>
                        </div>
                        <div class="m-widget4__img m-widget4__img--pic">
                          <i class="m-menu__link-icon  text-info fa-2x" :class="servicesConfig[service.name].icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </dash-content>
  </div>
</template>
<script>
  import api from "../../api";
  import Content from "../partials/Content";
  import helpers from "../../helpers";
  import BreadCrumb from "../partials/BreadCrumb";
  import servicesConfig from "../../config/services";

  export default {
    name: "countyservices",
    data() {
      return {
        loading: false,
        token: this.$store.state.token || window.localStorage.getItem("token"),
        params: this.$route.params,
        servicesConfig: servicesConfig
      };
    },
    components: {
      "dash-content": Content,
      BreadCrumb
    },
    computed: {
      services() {
        return this.$store.state.services ? this.$store.state.services : [];
      }
    },
    created: function () {
      let data = {
        countyId: this.params.countyId,
        token: this.token
      };
      const txType = "get-modules";
      helpers.loading(true);
      api
        .request(txType, data)
        .then(response => {
          if (response.data.status === "00") {
            helpers.loading(false);
            this.setServices(response.data.modules);
          } else {
            helpers.info({show: true, message: response.data.message});
            this.resetServices();
          }
        })
        .catch(error => {
          helpers.error({
            show: true,
            message: "An error occured. Please try again later."
          });
          console.log("The following error occurred: " + error);
        });
    },
    methods: {
      resetServices() {
        this.$store.commit("SET_SERVICES", false);
        if (window.localStorage) {
          window.localStorage.removeItem("services");
        }
      },
      setServices(services) {
        this.$store.commit("SET_SERVICES", services);
        if (window.localStorage) {
          window.localStorage.setItem("services", JSON.stringify(services));
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/partials/CountyServices.vue